import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import Radio, { Option } from '@Components/Fields/Radio'
import { statusMFAOptionsMockProps } from '@Const/default-options'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import PhoneInput from 'react-phone-number-input/max'
import flags from 'react-phone-number-input/flags'
import 'react-phone-number-input/style.css'
import { joinPhoneNumber, splitPhoneNumber } from '@Entities/schemas/common/international-phone-number-schema'
import './index.scss'

interface ConfigurationMFAProps {
    loading: boolean
    setLoading: (val: boolean) => void
    isLoggingIn?: boolean
}

const ConfigurationMFA = (props: ConfigurationMFAProps) => {
    const { createPasswordStore } = useContext(StoresContext)
    const { isEmailMFA, email, phoneCountryCode, fullPhoneNumber, phoneNumberValidation } = createPasswordStore

    const displayValue = joinPhoneNumber({ phoneCountryCode, fullPhoneNumber })

    const setMFAType = (data: Option) => {
        const isEmailMFALocal = data.value === 'email'
        createPasswordStore.setIsMFAType(isEmailMFALocal)
        if (isEmailMFALocal) {
            createPasswordStore.setIsConfigMFAValid(true)
        }
    }

    const handlePhoneChange = (value?: string) => {
        const phoneNumber = splitPhoneNumber(value)
        createPasswordStore.getValue(phoneNumber.phoneCountryCode, 'phoneCountryCode')
        createPasswordStore.getValue(phoneNumber.fullPhoneNumber, 'fullPhoneNumber')
        createPasswordStore.validatorConfigMFA()
    }

    const submitConfigurationMFA = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        props.setLoading(true)
        await createPasswordStore.submitConfigurationMFA()
        props.setLoading(false)
    }

    useEffect(() => createPasswordStore.validatorConfigMFA(), [])

    return (
        <div className="global-container">
            <form className="config-mfa-form" onSubmit={submitConfigurationMFA}>
                <h3>Configure account security</h3>
                <p>
                    The MLC Portal requires{' '}
                    <strong>
                        {' '}
                        Multi-Factor <br /> Authentication (MFA){' '}
                    </strong>
                    to secure your account <br /> login. Please choose email or mobile options <br /> below:
                </p>
                <div className="radio-buttons">
                    <Radio {...statusMFAOptionsMockProps} onChange={setMFAType} defaultCheckedId={2} />
                </div>
                {isEmailMFA ? (
                    <p>
                        Your account email address will be used for MFA: <strong>{email}</strong>
                    </p>
                ) : (
                    <>
                        <p>Your account phone will be used for MFA: </p>
                        <PhoneInput
                            flags={flags}
                            defaultCountry="US"
                            international
                            limitMaxLength
                            value={displayValue}
                            onChange={handlePhoneChange}
                        />
                        {phoneNumberValidation.fullPhoneNumber.error && (
                            <span className="error">{phoneNumberValidation.fullPhoneNumber.error}</span>
                        )}
                        <p>
                            Please enter a mobile number that can receive text messages. MFA codes will be sent via text
                            to this number.
                        </p>
                    </>
                )}
                <Button mainColor type="primary" disabled={!createPasswordStore.isConfigMFAValid || props.loading}>
                    Update MFA Settings
                </Button>
            </form>
        </div>
    )
}

export default observer(ConfigurationMFA)
